// extracted by mini-css-extract-plugin
export default {"inputError":"errors_inputError__ZF-AH"};